import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import App from './App';
import { Fallo } from './components/Fallo';
import { protegerDelTraductor } from './lib/traductor';
import './i18n';
// Nunito Variable, self-hosted: the portal must render correctly offline
// and on networks that block Google Fonts.
import '@fontsource-variable/nunito';
import '@fontsource-variable/nunito/wght-italic.css';
import './styles/global.css';

protegerDelTraductor();

const el = document.getElementById('root');
if (!el) throw new Error('#root not found');

// The single-file demo build is opened straight from a static host with no
// server-side rewrites, so it routes on the hash instead of real paths.
const Router = import.meta.env.VITE_SINGLEFILE ? HashRouter : BrowserRouter;

createRoot(el).render(
  <StrictMode>
    <Fallo>
      <Router>
        <App />
      </Router>
    </Fallo>
  </StrictMode>,
);
